import React from 'react';
import MigrationList from './MigrationList';
export default function MigrationAccesses() {
    return <MigrationList url={'access'} keyLabel="name" />
};